import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class HelperService {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  private state: { [key: string]: any } = {};

  constructor() {}

  // Set value and persist until application restart or change
  setValue<T>(key: string, value: T): void {
    this.state[key] = value;
  }

  // Get previously set value (e.g. user preference)
  getValue<T>(key: string): T | null {
    return this.state[key] !== undefined ? (this.state[key] as T) : null;
  }
}
